import { callPlanet } from './'

export const pickersCall = (
  countryCode,
  cultureCode,
  departureCity,
  marketId,
  nights,
  packageKey,
  productKey,
  saleKey,
  version,
  isResourceV2 = false
) => {
  const uri = isResourceV2
    ? 'Search/v2/Dates'
    : 'Search/Dates'

  const body = {
    countryCode,
    cultureCode,
    departureCity,
    eventKey: saleKey,
    marketId,
    nightCount: nights,
    packageKey,
    productKey,
    version
  }

  return callPlanet(uri, body)
}
